module.exports = __webpack_public_path__ + "img/presentation.3773884.png";